var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6.5V17.5L12 22.5L21 17.5V6.5L12 2L3 6.5ZM5 8.75507V16.3232L11 19.6565V12.0884L5 8.75507ZM13 12.0884V19.6565L19 16.3232V8.75507L13 12.0884ZM17.7979 7.135L12 4.23607L6.20213 7.135L12 10.356L17.7979 7.135Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9713 10.9283L5.97129 8.15056C4.63822 7.40997 3 8.3739 3 9.89887V16.323C3 17.0494 3.39378 17.7186 4.02871 18.0714L9.02871 20.8491C10.3618 21.5897 12 20.6258 12 19.1008V12.6767C12 11.9503 11.6062 11.2811 10.9713 10.9283Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockSolid);
export default __webpack_public_path__ + "static/media/block-solid.a9722bc03782051901cb743746a27e72.svg";
export { ForwardRef as ReactComponent };